import {Component, OnInit} from '@angular/core';
import {Response} from '@angular/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ReportDatepickerComponent } from '../../modals/report-datepicker.component';
import { ReportType } from '../../models/report-type.model';
import {AdminService} from '../../services/admin.service';
import { SortTableService } from '../../services/sort-table.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-company-structure',
  templateUrl: './company-structure.component.html',
  styleUrls: ['./company-structure.component.css']
})
export class CompanyStructureComponent implements OnInit {
  noGroupsInfo = true;
  getGroupsErrorInfo = false;
  isLoaded = false;
  allGroupList: any;
  dataListVector = [];
  suc = false;
  nodata = false;
  isAdmin = false;
	isUser = false;
	isHead = false;
  user;
  mainGroup;

  constructor(private adminService: AdminService,
    public sortTableService: SortTableService, private modalService: NgbModal, public userService: UserService ) {
      this.mainGroup = JSON.parse(localStorage.getItem('User')).mainGroup;
  }

  ngOnInit() {
    this.checkRole();
    this.adminService.getAllGroups().subscribe(
      (response: any) => {
        this.allGroupList = response.body;
        this.sortTableService.sortList('allGroupList', this.allGroupList, 'title');
        this.getGroupsErrorInfo = false;
        if (this.allGroupList.length > 0) {
          this.noGroupsInfo = false;
        } else {
          this.noGroupsInfo = true;
        }
       
        this.isLoaded = true;
      },
      () => {
        this.noGroupsInfo = true;
        this.getGroupsErrorInfo = true;
        this.isLoaded = true;
      }
    );
  }

  checkRole() {
		this.user = this.userService.getLocal();
		if (this.user.roles.indexOf('ROLE_HEAD') !== -1) {
			this.isHead = true;
		} else {
			this.isHead = false;
		}
		if (this.user.roles.indexOf('ROLE_ADMIN') !== -1) {
			this.isAdmin = true;
		} else {
			this.isAdmin = false;
		}
		if (this.user.roles.indexOf('ROLE_USER') !== -1) {
			this.isUser = true;
		} else {
			this.isUser = false;
		} 
	}

  openReportDatepickerVector() {
		this.dataListVector = [];
		const modalRef = this.modalService.open(ReportDatepickerComponent);
		modalRef.componentInstance.reportType = ReportType.BY_VECTOR_ALL_GROUP;
		modalRef.result.then((result) => {
			if (result === 'ok') {
				this.dataListVector = JSON.parse(localStorage.getItem('dataList'));
        
				if(this.dataListVector.length === 0) {
					this.nodata = true;
					setTimeout(() => this.nodata = false, 3000);
				} else {
					this.suc = true;
					setTimeout(() => this.suc = false, 3000);
				}
			}
		});
	}
 
}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/company-structure/company-structure.component.ts